import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { formatMoney } from "./formatMoney";
export const MoneyFormatted = (props) => {
    const classes = classNames(props.className, "money");
    return _jsx("span", { className: classes, children: formatMoney(props.amount) });
};
